import { IntakeFormCustomQuestionAnswerDto } from 'actions/intakeForm/IntakeFormDtos';
import { IntakeFormCustomQuestionAnswer } from 'types/IntakeForm';

export const convertToIntakeFormAnswerDto = (
    answer: IntakeFormCustomQuestionAnswer
): IntakeFormCustomQuestionAnswerDto => {
    return {
        question_snapshot: answer.question,
        custom_question_id: answer.questionId,
        answer: answer.answer
    };
};
